import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs, setDoc, doc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase/firebase.js";
import { useParams } from "react-router-dom";

function RedirectEditPage() {
  const { link } = useParams();
  const [currentLink, setCurrentLink] = useState("");
  const [newLink, setNewLink] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageId, setPageId] = useState(null); // Speichert die ID des Dokuments in Firestore

  function normalizeExternalUrl(href) {
    if (href.startsWith("http://") || href.startsWith("https://")) {
      return href;
    }
    return `https://${href}`;
  }

  // Funktion zur Suche der Seite anhand des Links
  const fetchPageByLink = async (link) => {
    const pagesRef = collection(db, "pages");
    const q = query(pagesRef, where("link", "==", link));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      throw new Error("Seite nicht gefunden.");
    }

    return querySnapshot.docs[0]; // Gibt das erste gefundene Dokument zurück
  };

  useEffect(() => {
    const fetchCurrentLink = async () => {
      try {
        const pageDoc = await fetchPageByLink(link);
        const data = pageDoc.data();

        if (data.content?.url) {
          setCurrentLink(data.content.url);
          setNewLink(data.content.url);
        }
        setPageId(pageDoc.id); // Speichert die Dokument-ID für spätere Änderungen
      } catch (error) {
        console.error("Fehler beim Laden der Weiterleitung:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentLink();
  }, [link]);

  const handleSave = async () => {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      alert("Du musst angemeldet sein, um Änderungen zu speichern.");
      return;
    }

    if (!newLink) {
      alert("Bitte gib einen gültigen Link ein.");
      return;
    }

    if (!pageId) {
      alert("Fehler: Seite konnte nicht gefunden werden.");
      return;
    }

    try {
      const pageRef = doc(db, "pages", pageId);
      const normalizedUrl = normalizeExternalUrl(newLink);

      // Aktualisiere die Weiterleitung in der Datenbank
      await setDoc(
        pageRef,
        {
          contentType: "url",
          content: { url: normalizedUrl },
          ownerId: currentUser.uid,
          updatedAt: new Date(),
        },
        { merge: true }
      );

      setCurrentLink(normalizedUrl);
      setNewLink(normalizedUrl);

      alert("Weiterleitung erfolgreich gespeichert!");
    } catch (error) {
      console.error("Fehler beim Speichern der Weiterleitung:", error);
      alert("Fehler beim Speichern der Weiterleitung.");
    }
  };

  if (loading) {
    return <p>Lädt...</p>;
  }

  return (
    <div className="container d-flex flex-column align-items-center mt-5">
      <h1 className="mb-4">Weiterleitung bearbeiten</h1>
      <div className="mb-3 w-100" style={{ maxWidth: "600px" }}>
        <label htmlFor="redirectInput" className="form-label">
          Aktuelle Weiterleitung
        </label>
        <input
          type="url"
          id="redirectInput"
          className="form-control"
          value={newLink}
          onChange={(e) => setNewLink(e.target.value)}
        />
      </div>
      <button type="button" className="btn btn-primary mt-3" onClick={handleSave}>
        Speichern
      </button>
    </div>
  );
}

export default RedirectEditPage;
